import {fadeIn, fadeOut} from '../general/functions';
import axios from "axios";

export default class Order {
    constructor() {
        if (document.querySelector('#pageAccount.edit') !== null || document.querySelector('#pageAccount.register') !== null) {
            this.initAccountType();
            this.initVat();
        }

        if (document.querySelector('#pageAccount.addresses') !== null) {
            this.initDeleteAddress();
        }

        if (document.querySelector('#pageAccount.create-address') !== null ||
            document.querySelector('#pageAccount.edit-address') !== null) {
            this.initPostalCode();
        }
    }

    initAccountType() {
        const radios = document.querySelectorAll('input[name=account_type]');
        const businessWrapper = document.getElementById('businessWrapper');

        radios.forEach(radio => {
            radio.addEventListener('change', e => {
                if (radio.value === 'business') {
                    fadeIn(businessWrapper);
                } else {
                    fadeOut(businessWrapper);
                }
            });
        });
    }

    initVat() {
        const inputVatNumber = document.getElementById('inputVatNumber');
        const vatMessage = document.querySelector('#inputVatNumber + small');
        let typingTimer;
        let doneTypingInterval = 1000;
        const CancelToken = axios.CancelToken;
        let source;

        inputVatNumber.addEventListener('keyup', () => {
            if (source) {
                source.cancel();
            }
            clearTimeout(typingTimer);
            if (inputVatNumber.value) {
                inputVatNumber.value = inputVatNumber.value.replace(/[^\d\w]/g, '');
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            }
        });

        const that = this;

        function doneTyping() {
            source = CancelToken.source();

            axios({
                method: 'post',
                url: '/btw-valideren',
                data: {
                    'vat': inputVatNumber.value
                },
                cancelToken: source.token
            })
                .then(response => { // success
                    if (response.data) {
                        fadeOut(vatMessage);
                    } else {
                        fadeIn(vatMessage);
                    }
                })
                .catch(function (error) { // error
                    console.log(error);
                })
                .then(function () { // always
                });
        }

        if (inputVatNumber.value !== '') {
            const event = document.createEvent('HTMLEvents');
            event.initEvent('keyup', true, false);
            inputVatNumber.dispatchEvent(event);
        }
    }

    initDeleteAddress() {
        let addresses = document.querySelectorAll('.address-card');

        addresses.forEach(address => {
            let deleteButton = address.querySelector('.delete-button');
            let url = deleteButton.getAttribute('href');

            deleteButton.addEventListener('click', e => {
                e.preventDefault();

                axios({
                    method: 'delete',
                    url: url
                })
                    .then(response => { // success
                        let data = response.data;
                        if(data === 1) {
                            fadeOut(address);
                        }
                    })
                    .catch(function (error) { // error
                        console.log(error);
                    })
                    .then(function () { // always
                    });
            });
        });
    }

    initPostalCode() {
        let postalCode = document.querySelector('.postal-code');
        let houseNumber = document.querySelector('.house-number');
        let street = document.querySelector('.street');
        let city = document.querySelector('.city');

        [postalCode, houseNumber].forEach(item => {
            item.addEventListener('blur', e => {
                if (postalCode.value !== '' && houseNumber.value !== '') {
                    axios({
                        method: 'post',
                        url: '/postcode',
                        data: {
                            postal_code: postalCode.value,
                            house_number: houseNumber.value
                        }
                    })
                        .then(response => { // success
                            let data = response.data;
                            street.value = data.street;
                            city.value = data.city;
                            postalCode.value = data.postal_code;
                        })
                        .catch(function (error) { // error
                            street.value = '';
                            city.value = '';
                        })
                        .then(function () { // always
                        });
                }
            });
        });
    }
}
